export default __webpack_public_path__ + "static/media/heart-blue.6517a93b.svg";